module.exports = exports = {
  BLINDINSIGHT_PROXY_URL: "https://proxy.local.blindinsight.io",
  BLINDINSIGHT_UI_SENTRY_DSN: "",
  BLINDINSIGHT_STRIPE_PUBLISHABLE_KEY:
    "pk_live_51OyyPU2LBQb5RXBfdllEfqqHx276ACzNLXNrrFePPQadx5C0LEsDQdeHsY7dP2602KSO7RkxnxDB9GFPeEg79EdW00IQbe4i6j",
  BLINDINSIGHT_STRIPE_PRICING_TABLE_ID: "prctbl_1QjreR2LBQb5RXBf138g85IX",
  BLINDINSIGHT_STRIPE_BILLING_URL:
    "https://billing.stripe.com/p/login/5kAg0XfJU5cQ6Vq8ww",
  BLINDINSIGHT_GOOGLE_CLIENT_ID:
    "258925018220-f7a0nql23g3fcb94ubq3ihj13o2ov8on.apps.googleusercontent.com",
}
